import { Stack, Typography } from '@mui/material';

export const DrawerMeta = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => (
  <Stack direction="column" spacing={0.5}>
    <Typography
      variant="h2"
      sx={{
        textTransform: 'uppercase',
        fontFamily: "'Roboto', sans-serif",
        fontSize: '0.75em',
        fontWeight: '500',
        color: '#cccff8',
      }}
    >
      {title}
    </Typography>
    <Typography
      variant="h1"
      sx={{
        fontSize: '1em',
        fontWeight: '700',
      }}
    >
      {subtitle}
    </Typography>
  </Stack>
);

export const DrawerComponentMeta = ({
  component,
}: {
  component: React.ReactElement;
}) => {
  return (
    <Stack direction="column" spacing={0.5}>
      {component}
    </Stack>
  );
};

export const ImageDrawerHeaderMeta = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => (
  <Stack direction="column" spacing={0.5}>
    <Typography
      variant="h2"
      sx={{
        textTransform: 'uppercase',
        fontFamily: "'Roboto', sans-serif",
        fontSize: '0.625rem',
        fontWeight: '500',
        color: '#cccff8',
      }}
    >
      {title}
    </Typography>
    <Typography
      variant="h1"
      sx={{
        fontSize: '0.875rem',
        fontWeight: '700',
      }}
    >
      {subtitle}
    </Typography>
  </Stack>
);
